import { types } from './menu.actions.js';

const initialState = {
  items: [],
  currentRecord: null,
  notifications: [{
    read: false
  }],
}

function findMenuByPath(path, menuItems) {
  let menuFinded = null
  menuItems.forEach(menuItem => {
    if (menuItem.path === path) {
      menuFinded = menuItem
    }
    if (menuItem.items) {
      const resultChildren = findMenuByPath(path, menuItem.items)
      if (resultChildren) {
        menuFinded = resultChildren
      }
    }
  });
  return menuFinded
}

export function menuReducer(state = initialState, action) {
  if (action.type === types.MENU_SET_ITEMS) {
    return Object.assign({}, state, { items: action.items || [] })
  } else if (action.type === types.MENU_CLEAR_ITEMS) {
    return Object.assign({}, state, { items: [] })
  } else if (action.type === types.SET_CURRENT_RECORD) {
    const currentMenu = findMenuByPath(action.menuPath, state.items)
    return Object.assign({}, state, { currentRecord: currentMenu })
  } else if (action.type == types.FETCH_NOTIFICATION) {
    return menuFetchNotification(state, action)
  } else if (action.type == types.READ_NOTIFICATION) {
    return menuReadNotification(state, action)
  }
  return state;
}

function menuFetchNotification(state, action) {
  let notifications = state.notifications
  notifications = action.notifications

  return { ...state, notifications }
}

function menuReadNotification(state, action) {

  let notifications = state.notifications
  for (let index = 0; index < notifications.length; index++) {
    if (notifications[index].id == action.idNotification){
      notifications[index].read = true
      return {...state,notifications}
    }
  }
  return {state}
}
